import React from "react";

import { useTranslation } from "react-i18next";

import { useNeighborhoodHero } from "~/sdks/NeighborhoodHero/context";
import * as styles from "./styles";

export const Summary = () => {
  const { t } = useTranslation("neighborhoodHero");
  const { neighborhoodSummary } = useNeighborhoodHero();

  if (!neighborhoodSummary) {
    return null;
  }

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>{t("summaryTitle")}</h2>
      <p className={styles.text} data-cy="summary">
        {neighborhoodSummary}
      </p>
    </div>
  );
};
